import { IVideoContent } from "../../../../models";
import React, { SyntheticEvent, useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { toastError, toastSuccess } from "../../../../utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import {
  addLabelToCategory,
  getLabelsOfNotCategory,
} from "../../../../services";
import { Image } from "primereact/image";
import NoImage from "../../../../assets/images/no-image.png";
import { ILabelDefinition } from "@/models";

interface AddLabelToCategoryDialogProps {
  visible: boolean;
  onHide: () => void;
  refreshTable: () => void;
  categoryId: number | null;
}

const AddLabelToCategoryDialog: React.FC<AddLabelToCategoryDialogProps> = ({
  visible,
  onHide,
  refreshTable,
  categoryId,
}) => {
  const toast = useRef<Toast>(null);

  const [labelList, setLabelList] = useState<ILabelDefinition[] | undefined>(
    []
  );
  const [listChanged, setListChanged] = useState(false);

  useEffect(() => {
    try {
      getLabelsOfNotCategory(categoryId).then((response) => {
        //console.log("getAllContentsNotOfLabel.response:", response);
        if (response && response.length > 0) {
          setLabelList(response);
        }
      });
    } catch (error) {}
  }, [visible, listChanged]);

  const addToCategory = (rowData: ILabelDefinition) => {
    try {
      addLabelToCategory(categoryId, rowData?.id).then((response) => {
        //console.log("addMainBoardItem.response:", response);

        //setSelectedContentForAdd(null);
        setListChanged(!listChanged);
        refreshTable();
        showSuccess();
      });
    } catch (error) {
      showFail(null);
    }
  };

  const onHideLocal = () => {
    //setSelectedContentForAdd(null);
    //setContentList([]);
    refreshTable();
    onHide();
  };

  const showSuccess = () => {
    toastSuccess(toast, "Operation successful.");
  };

  const showFail = (message: string | null) => {
    toastError(toast, message ? message : "Operation failed.");
  };

  const imageBodyTemplate = (rowData: IVideoContent) => {
    return (
      <Image
        src={`${rowData.catalogPosterUrl}`}
        alt="videoContent"
        height="80"
        width="80"
        preview
        className="videoContent-image"
        onError={(e: SyntheticEvent<HTMLImageElement, Event>) => {
          (e.target as HTMLImageElement).src = NoImage;
        }}
      />
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        visible={visible}
        style={{ width: "50%" }}
        header={"Add Content To MBI List"}
        modal
        className="p-fluid"
        footer={
          <Button
            label={"Close"}
            icon="pi pi-times"
            className="p-button-text"
            onClick={onHideLocal}
          />
        }
        onHide={onHide}
      >
        <div className="">
          <DataTable
            value={labelList}
            responsiveLayout="scroll"
            paginator
            rows={15}
            rowsPerPageOptions={[5, 10, 25, 50]}
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            filterDisplay="row"
          >
            <Column field="id" header="ID"></Column>
            <Column
              field="name"
              header="Name"
              filter
              filterPlaceholder="Search by name"
            ></Column>

            <Column
              body={(rowData: ILabelDefinition) => (
                <>
                  <Button
                    icon="pi pi-plus"
                    className="p-button-rounded p-button-outlined m-1"
                    onClick={() => addToCategory(rowData)}
                    style={{ width: "2rem", height: "2rem" }}
                  />
                </>
              )}
              exportable={false}
              style={{ width: "10%" }}
            />
          </DataTable>
        </div>
      </Dialog>
    </>
  );
};

export default AddLabelToCategoryDialog;
